let stylesInjected = false;

export const injectStyles = () => {
  if (stylesInjected || typeof document === 'undefined') return;

  const styleId = 'popup-menu-styles';

  if (document.getElementById(styleId)) {
    stylesInjected = true;
    return;
  }

  const cssContent = `
    .popup-menu-wrapper {
      position: relative;
      display: inline-block;
    }

    .popup-menu {
      position: fixed;
      opacity: 0;
      transition: opacity 0.2s ease, transform 0.2s ease;
      z-index: 50;
      display: flex;
      flex-direction: column;
      background-color: white;
      border-radius: 0.5rem;
      overflow: hidden;
      border: 1px solid #e0e1e4;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
      min-width: 120px;
    }

    .popup-menu.dark-theme {
      background-color: #404040;
      color: #F9F9F9;
      border: 1px solid #606060;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -2px rgba(0, 0, 0, 0.25);
    }

    .popup-menu-visible {
      opacity: 1;
    }

    /* Default (scale) animations */
    .popup-menu-from-top {
      transform: scale(0.95);
      transform-origin: bottom;
    }

    .popup-menu-from-bottom {
      transform: scale(0.95);
      transform-origin: top;
    }

    .popup-menu-from-left {
      transform: scale(0.95);
      transform-origin: right;
    }

    .popup-menu-from-right {
      transform: scale(0.95);
      transform-origin: left;
    }

    .popup-menu-visible {
      transform: scale(1);
    }

    /* "In" animations */
    .popup-menu-in {
      transform: translate(0, 0);
      opacity: 1;
    }

    .popup-menu-in-from-top {
      transform: translateY(10px);
    }

    .popup-menu-in-from-bottom {
      transform: translateY(-10px);
    }

    .popup-menu-in-from-left {
      transform: translateX(10px);
    }

    .popup-menu-in-from-right {
      transform: translateX(-10px);
    }

    /* "Out" animations */
    .popup-menu-out {
      transform: translate(0, 0);
      opacity: 1;
    }

    .popup-menu-out-from-top {
      transform: translateY(-10px);
    }

    .popup-menu-out-from-bottom {
      transform: translateY(10px);
    }

    .popup-menu-out-from-left {
      transform: translateX(-10px);
    }

    .popup-menu-out-from-right {
      transform: translateX(10px);
    }

    .popup-menu-header {
      border-bottom: 1px solid #e0e1e4;
      padding: 0.5rem;
      font-size: 1rem;
      font-weight: 600;
      text-align: center;
    }

    .popup-menu.dark-theme .popup-menu-header {
      border-bottom: 1px solid #606060;
    }

    .popup-menu-footer {
      border-top: 1px solid #e0e1e4;
      padding: 0.5rem;
      font-size: 1rem;
      font-weight: 600;
      text-align: center;
    }

    .popup-menu.dark-theme .popup-menu-footer {
      border-top: 1px solid #606060;
    }

    .popup-menu-content {
      display: flex;
      flex-direction: column;
      padding: 0.25rem;
      max-height: 50vh;
      overflow-y: auto;
    }

    .popup-menu-item {
      padding: 0.25rem 0.5rem;
      border-radius: 0.25rem;
      cursor: pointer;
      transition: background-color 0.2s ease;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .popup-menu-item:hover {
      background-color: #dee3ee;
    }

    .popup-menu.dark-theme .popup-menu-item:hover {
      background-color: #555555;
    }

    .cursor-pointer {
      cursor: pointer;
    }
  `;

  const styleElement = document.createElement('style');
  styleElement.id = styleId;
  styleElement.textContent = cssContent;

  document.head.appendChild(styleElement);
  stylesInjected = true;
};